import { InjectionToken } from '@angular/core';
import { StepType } from '@selfai-platform/aggregator-api';

export const AGGREGATOR_STEPS_CONFIG = new InjectionToken<StepType[]>('AggregatorStepsConfig');
